import "./addPublisher.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import {
  collection,
  doc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  where,
} from "firebase/firestore";
import { db, functions } from "../../firebase";
import { httpsCallable } from "firebase/functions";
import { generateKeywords } from "../../functions";
import { handleInputNumber } from "../../context/commonFunctions";

const AddPublisher = () => {
  const [isEmailAvailable, setIsEmailAvailable] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [radioTypeValue, setRadioTypeValue] = useState("full");
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    emailAddress: "",
    password: "",
    experience: 0,
    booksWritten: 0,
    currentInstitute: "",
    city: "",
    pincode: 0,
    department: "",
  });
  const [formErrors, setFormErrors] = useState({
    fullName: "",
    phoneNumber: "",
    emailAddress: "",
    password: "",
    experience: "",
    booksWritten: "",
    currentInstitute: "",
    city: "",
    pincode: "",
    department: "",
    commission: "",
  });
  const checkEmailInFirestore = async (email) => {
    try {
      const publisherRef = collection(db, "publishers");
      const q = query(publisherRef, where("emailAddress", "==", email));
      const querySnapshot = await getDocs(q);
      return !querySnapshot.empty;
    } catch (error) {
      console.error("Error checking email in Firestore:", error);
      return false;
    }
  };
  const handleEmailInput = async (event) => {
    const email = event.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      const isEmailInFirestore = await checkEmailInFirestore(email);
      setIsEmailAvailable(!isEmailInFirestore);
      if (isEmailInFirestore) {
        setFormErrors({
          ...formErrors,
          emailAddress: "This email address is already register with us.",
        });
      } else {
        setFormErrors({ ...formErrors, emailAddress: "" });
        setFormData({ ...formData, emailAddress: event.target.value });
      }
    } else {
      setIsEmailAvailable(false);
      setFormErrors({ ...formErrors, emailAddress: "" });
    }
  };
  const validateForm = () => {
    const errors = {
      fullName: "",
      phoneNumber: "",
      emailAddress: "",
      password: "",
      experience: "",
      booksWritten: "",
      currentInstitute: "",
      city: "",
      pincode: "",
      department: "",
      commission: "",
    };

    let isValid = true;

    if (!formData.fullName.trim()) {
      errors.fullName = "Publisher Name cannot be empty";
      isValid = false;
    }
    if (!formData.phoneNumber.trim() || formData.phoneNumber.length < 10) {
      errors.phoneNumber = "Invalid Phone number";
      isValid = false;
    }
    if (!formData.emailAddress.trim()) {
      errors.emailAddress = "Email Address cannot be empty";
      isValid = false;
    }
    if (!formData.password.trim()) {
      errors.password = "Password cannot be empty";
      isValid = false;
    }
    if (!formData.experience) {
      errors.experience = "Experience cannot be empty";
      isValid = false;
    }
    if (!formData.commission) {
      errors.commission = "Commission cannot be empty";
      isValid = false;
    }
    if (!formData.booksWritten) {
      errors.booksWritten = "No. of books written cannot be empty/zero";
      isValid = false;
    }
    if (!formData.currentInstitute.trim()) {
      errors.currentInstitute = "Institute name cannot be empty";
      isValid = false;
    }
    if (!formData.city.trim()) {
      errors.city = "City cannot be empty";
      isValid = false;
    }
    if (!formData.department.trim()) {
      errors.department = "Department cannot be empty";
      isValid = false;
    }
    if (!formData.pincode || formData.pincode === 0) {
      errors.pincode = "Pincode cannot be empty/zero";
      isValid = false;
    }
    if (!isEmailAvailable) {
      errors.emailAddress = "Cannot use this email address right now!";
      isValid = false;
    }

    setFormErrors(errors);

    return isValid;
  };

  const hanldeRegisterUser = () => {
    if (validateForm()) {
      setLoading(true);
      const createPublisher = httpsCallable(functions, "createPublisher");
      createPublisher({
        email: formData.emailAddress,
        password: formData.password,
      })
        .then(async (result) => {
          const publisherUid = result.data.uid;
          try {
            var mapData = formData;
            mapData = {
              ...mapData,
              accountCreatedOn: serverTimestamp(),
              controlAccess: radioTypeValue,
              totalSale: 0,
              unitSold: 0,
              walletBalance: 0,
              searchKeywords: generateKeywords(formData.fullName),
            };
            const publisherRef = doc(db, "publishers", publisherUid);
            await setDoc(publisherRef, mapData);
            setLoading(false);
            alert("Publisher Added Successfully");
            window.location.reload();
          } catch (error) {
            setLoading(false);
            alert("Error creating publisher account: " + error);
          }
        })
        .catch((error) => {
          setLoading(false);
          if (
            error.message ===
            "The email address is already in use by another account."
          ) {
            alert("The email address is already in use by another account.");
          }
          console.error("Error :", error.message);
        });
    }
  };
  const handleRadioType = (event) => {
    setRadioTypeValue(event.target.value);
  };
  useEffect(() => {
    document.title = "Wishallbook >> Register Publisher";
  }, []);

  return (
    <div className="addPublisher">
      <Sidebar />
      <div className="addPublisherContainer">
        <Navbar />
        <div className="top">
          <h1>{"Register Publisher"}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <div className="form">
              <div className="formInput" key={"fullName"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Full Name"
                  onChange={(e) => {
                    setFormData({ ...formData, fullName: e.target.value });
                  }}
                  error={formErrors.fullName !== ""}
                  helperText={formErrors.fullName}
                />
              </div>
              <div className="formInput" key={"phoneNumber"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Phone number"
                  onInput={handleInputNumber}
                  inputProps={{ maxLength: 10 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">+91</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      phoneNumber: e.target.value,
                    });
                  }}
                  error={formErrors.phoneNumber !== ""}
                  helperText={formErrors.phoneNumber}
                />
              </div>

              <div className="formInput" key={"emailAddress"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Email Address"
                  onChange={handleEmailInput}
                  error={formErrors.emailAddress !== ""}
                  helperText={formErrors.emailAddress}
                />
              </div>

              <div className="formInput" key={"password"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Password"
                  onChange={(e) => {
                    setFormData({ ...formData, password: e.target.value });
                  }}
                  error={formErrors.password !== ""}
                  helperText={formErrors.password}
                />
              </div>
              <div className="formInput" key={"experience"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Teaching Experience"
                  inputProps={{ maxLength: 2 }}
                  onInput={handleInputNumber}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">years</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    const currentYear = new Date().getFullYear();
                    setFormData({
                      ...formData,
                      experience:
                        currentYear - (parseInt(e.target.value, 10) || 0),
                    });
                  }}
                  error={formErrors.experience !== ""}
                  helperText={formErrors.experience}
                />
              </div>
              <div className="formInput" key={"booksWritten"}>
                <TextField
                  fullWidth
                  onInput={handleInputNumber}
                  inputProps={{ maxLength: 4 }}
                  id="outlined-multiline-static"
                  label="No. of Books Written"
                  onChange={(e) => {
                    setFormData({ ...formData, booksWritten: e.target.value });
                  }}
                  error={formErrors.booksWritten !== ""}
                  helperText={formErrors.booksWritten}
                />
              </div>
              <div className="formInput" key={"currentInstitute"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Current College or Institution Name"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      currentInstitute: e.target.value,
                    });
                  }}
                  error={formErrors.currentInstitute !== ""}
                  helperText={formErrors.currentInstitute}
                />
              </div>
              <div className="formInput" key={"city"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="City of Residence"
                  onChange={(e) => {
                    setFormData({ ...formData, city: e.target.value });
                  }}
                  error={formErrors.city !== ""}
                  helperText={formErrors.city}
                />
              </div>

              <div className="formInput" key={"pincode"}>
                <TextField
                  fullWidth
                  onInput={handleInputNumber}
                  id="outlined-multiline-static"
                  inputProps={{ maxLength: 6 }}
                  label="Pincode"
                  onChange={(e) => {
                    setFormData({ ...formData, pincode: e.target.value });
                  }}
                  error={formErrors.pincode !== ""}
                  helperText={formErrors.pincode}
                />
              </div>

              <div className="formInput" key={"department"}>
                <TextField
                  fullWidth
                  //onInput={handleInputNumber}
                  id="pages"
                  label="Academic Department"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      department: e.target.value,
                    });
                  }}
                  error={formErrors.department !== ""}
                  helperText={formErrors.department}
                />
              </div>
              <div className="formInput" key={"commission"}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Enter commission rate (per copy)"
                  onInput={handleInputNumber}
                  inputProps={{ maxLength: 2 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      commission: parseInt(e.target.value, 10) || 0,
                    });
                  }}
                  error={formErrors.commission !== ""}
                  helperText={formErrors.commission}
                />
              </div>
              <div className="formInput" key={"radioButton"}>
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group-type">
                    Control
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group-type"
                    value={radioTypeValue}
                    onChange={handleRadioType}
                  >
                    <FormControlLabel
                      value="full"
                      control={<Radio size="small" />}
                      label="Full Access"
                    />
                    <FormControlLabel
                      value="limited"
                      control={<Radio size="small" />}
                      label="Limited Access"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="formInput" key={"register"}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={hanldeRegisterUser}
                >
                  Create Publisher Account
                </Button>
              </div>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
              >
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress
                    color="inherit"
                    value={10}
                    sx={{ marginBottom: "15px" }}
                  />
                  <Typography>{true}</Typography>
                </Grid>
              </Backdrop>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPublisher;
